import { Badge } from "reactstrap";
import { DATE_FORMAT_VIEW } from "@src/utility/constants";
// import { dateFormatter } from "@/utils/date";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import capitalize from "lodash/capitalize";
import { getStatusBadge } from "@helpers/utils";
import useDateHandler from "@hooks/use-date-handler";
import { useTranslation } from "react-i18next";
export const decoColumns = ({ handleRowActions }) => {
    const { t } = useTranslation();
    const { dateFormatter } = useDateHandler();
    return [
        {
            name    : "Name",
            selector: row => row.name,
            width   : "280px",
            cell    : row => (
                <LongNameFormatter
                    content={row.name}
                    className="fw-bold"
                    id={`name-${row._id}`}
                    max={35}/>
            )
        },
        {
            name    : "Description",
            selector: row => row.description,
            width   : "350px",
            cell    : row => (
                <LongNameFormatter
                    content={row.description}
                    id={`description-${row._id}`}
                    max={35}/>
            )
        },
        {
            name    : "Total Companies",
            selector: row => row.clientCount,
            width   : "150px",
            cell    : row => <span>{row.clientCount}</span>
        },
        {
            name    : "Status",
            selector: row => row.status,
            width   : "120px",
            cell    : row => (
                <Badge color={getStatusBadge(row.status)?.color || "secondary"}>
                    {t(getStatusBadge(row.status)?.title || row.status)}
                </Badge>
            )
        },
        {
            name    : "Created On",
            selector: row => row.created_at,
            width   : "250px",
            cell    : row => (
                <span>
                    <i className="mdi mdi-calendar me-1 font-medium-2" />
                    {dateFormatter({
                        date    : row?.created_at,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </span>
            )
        },
        {
            name    : "Updated On and Updated By",
            selector: row => row.updated_at,
            width   : "280px",
            cell    : row => (
                row.updated_at ?    <Flex column>
                    <p className="mb-1">
                        <b>{t("Update On")}:&nbsp;</b>
                        {dateFormatter({
                            date    : row?.updated_at,
                            formatAs: DATE_FORMAT_VIEW
                        })}
                        
                    </p>
                    <p>
                        <b>{t("Update By")}:&nbsp;</b>
                        {capitalize(row?.updated_by?.name)}
                    </p>
                </Flex> : "-"
            )
        },
        {
            name: "Actions",
            cell: row => (
                <>
                    <LoadingButton
                        className="me-1"
                        outline
                        color="info"
                        id={`${row._id}-edit-button`}
                        testId={`${row._id}-edit-button`}
                        icon="pencil"
                        onClick={() => handleRowActions(row, "edit")}/>
                    <LoadingButton
                        className="text-danger"
                        outline
                        color="danger"
                        id={`${row._id}-edit-delete`}
                        testId={`${row._id}-delete-button`}
                        icon="delete"
                        onClick={() => handleRowActions(row, "delete")}/>
                </>
            )
        }
    ];
};
